module.exports = __webpack_public_path__ + "static/media/notify-comments.83a39daa.svg";